import { Context } from '@getaccept/editor-lib';

export class ContextHelper {
  static isDsrResourceOrTemplate = (context: Context) =>
    context === Context.DsrResource || context === Context.DsrTemplate;

  static isResourceOrTemplate = (context: Context) =>
    context === Context.DsrResource ||
    context === Context.DsrTemplate ||
    context === Context.ContractsTemplate;
}
